import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import * as colors from 'material-ui/styles/colors';


import FormText from '../../components/FormText'
import FormSelect from '../../components/FormSelect'


const validate = values => {
  const errors = {}
  const requiredFields = [
    "year", "month"
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })
  return errors
}

class RoumuDownloadForm extends React.Component {


  render() {

    const {
      auth,
      error,
      reset,
      handleSubmit,
      onDownload,
      onDownloadPdf,
     } = this.props

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}
        
          <div className="row">

             <div className="col-3">

              <Field
                name="year"
                component={FormSelect}
                style={{ width: '100%' }}
                label="年"
              >

                <MenuItem value={2017} primaryText={2017} />
                <MenuItem value={2018} primaryText={2018} />
                <MenuItem value={2019} primaryText={2019} />
                <MenuItem value={2020} primaryText={2020} />
                <MenuItem value={2021} primaryText={2021} />
                <MenuItem value={2022} primaryText={2022} />
                <MenuItem value={2023} primaryText={2023} />
                <MenuItem value={2024} primaryText={2024} />
                <MenuItem value={2025} primaryText={2025} />
                <MenuItem value={2026} primaryText={2026} />
                <MenuItem value={2027} primaryText={2027} />

              </Field>

            </div> 

             <div className="col-3">

               <Field
                 name="month"
                 component={FormSelect}
                 style={{ width: '100%' }}
                 label="月"
               >
                 <MenuItem value={12} primaryText={1} />
                 <MenuItem value={1} primaryText={2} />
                 <MenuItem value={2} primaryText={3} />
                 <MenuItem value={3} primaryText={4} />
                 <MenuItem value={4} primaryText={5} />
                 <MenuItem value={5} primaryText={6} />
                 <MenuItem value={6} primaryText={7} />
                 <MenuItem value={7} primaryText={8} />
                 <MenuItem value={8} primaryText={9} />
                 <MenuItem value={9} primaryText={10} />
                 <MenuItem value={10} primaryText={11} />
                 <MenuItem value={11} primaryText={12} />
               </Field>

            </div> 

          </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-12" style={{textAlign: 'right'}}>

              <FlatButton
                label="ダウンロードPDF"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '180px', marginRight: '20px' }}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                icon={<ArrowDwonloadIcon color={colors.white} />}
                onClick={handleSubmit(onDownloadPdf)}
              />

              {
                auth.user.permission == 2 &&
                <FlatButton
                  label="ダウンロードExcel"
                  labelPosition="before"
                  primary={true}
                  labelStyle={{color: colors.white, lineHeight: '40px'}}
                  style={{height: '40px', width: '200px'}}
                  backgroundColor={colors.grey600}
                  hoverColor={colors.grey800}
                  icon={<ArrowDwonloadIcon color={colors.white}/>}
                  onClick={handleSubmit(onDownload)}
                />
              }

            </div>

          </div>

      </form>

    )

  }

}

RoumuDownloadForm = reduxForm({
  form: 'roumuDownloadForm',
  enableReinitialize: true,
  validate
})(RoumuDownloadForm)

export default RoumuDownloadForm




// WEBPACK FOOTER //
// ./src/containers/roumu/RoumuDownloadForm.js